module.exports = __webpack_public_path__ + "static/media/CloseMobileMenu.02b42cfa.svg";